<template>
  <b-carousel
    v-bind="{ ...$props, ...$attrs }"
    :ref="id"
    v-on="$listeners"
    class="nan-carousel"
  >
    <slot></slot>
  </b-carousel>
</template>

<script>
import debounce from "lodash.debounce";

import id from "@/mixins/id";

export default {
  mixins: [id],

  data: () => ({
    debounceFunc: null
  }),

  mounted() {
    this.debounceFunc = debounce(this.setCarouselHeight, 300);
    window.addEventListener("resize", this.debounceFunc);
    this.setCarouselHeight();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.debounceFunc);
  },

  methods: {
    setCarouselHeight() {
      const carousel = this.$refs[this.id].$el;
      const slideList = carousel.childNodes[0];
      const slides = slideList.childNodes;
      let maxHeight = 0;
      slides.forEach(slide => {
        slide.classList.add("d-block");
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
        slide.classList.remove("d-block");
      });
      slideList.style.height = `${maxHeight}px`;
    }
  }
};
</script>

<style lang="scss">
.nan-carousel {
  .carousel-inner {
    display: flex;
    align-items: center;
  }
}
</style>
